import styles from './GeofenceVersionTime.module.scss';
import Skeleton from 'react-loading-skeleton';
import { useLocaleFormatter } from '@casops/shared/hooks/useLocaleFormatter';
import { useGetGeofenceVersionQuery } from '@casops/store/apis/geofencesApi';

export default function GeofenceVersionTime() {
  const { data } = useGetGeofenceVersionQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });
  const { parseFromIso, showTimeAndDate } = useLocaleFormatter();
  const version = data?.version;
  const rawTime = showTimeAndDate(parseFromIso(data?.time ?? ''));
  const time = rawTime === 'Invalid DateTime' ? '' : rawTime;
  const hasVersion = typeof version === 'number';
  const hasTime = !!time;
  const isLoaded = hasVersion || hasTime;

  return (
    <div className={styles.geofenceDetails}>
      {!isLoaded && <Skeleton width="120px" height="20px" />}
      {hasVersion && <div>V {version}</div>}
      {hasTime && <div>{time}</div>}
    </div>
  );
}
